<!-- crm半导体行业解决方案模块 -->

<template>
  <div class="crmSem_solution_box">
      <div class="sheets_box">
        <div
          class="sheet_content"
          :style="{
            'background-image': 'url(' + bgData + ')',
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            width: '1344px',
            height: '766px',
          }"
          :class="{ title_en: $i18n.locale === 'en_US',title_ja:$i18n.locale === 'ja_JP' }"     
        >
        
          <!-- 标题行 -->
          <div class="text_title title_height display_center" style="width:160px;top: 2.5rem; left: 2rem;">{{$t('solution_crm.semiconductor.solutions.headline.title01')}}</div>
          <div class="text_title title_height display_center" style="width:948px;top: 2.5rem; left: 19.8rem">{{$t('solution_crm.semiconductor.solutions.headline.title02')}}</div>
          <div class="text_title title_height display_center" style="width:168px;top: 2.5rem; right: 1.5rem">
            {{$t('solution_crm.semiconductor.solutions.headline.title03')}}
          </div>
          <div class="text_title title_height display_center" style="width:146px;top: 14.2rem; left: 19.8rem">{{$t('solution_crm.semiconductor.solutions.headline.title04')}}</div>
          <div class="text_title title_height display_center" style="width:290px;top: 14.2rem; left: 36.5rem">{{$t('solution_crm.semiconductor.solutions.headline.title05')}}</div>
          <div class="text_title title_height display_center" style="width:146px;top: 14.2rem; left: 67.2rem">
            {{$t('solution_crm.semiconductor.solutions.headline.title06')}}
          </div>
          <div class="text_title title_height display_center" style="width:146px;top: 14.2rem; left: 83.5rem">
            {{$t('solution_crm.semiconductor.solutions.headline.title07')}}
          </div>
          <div class="text_title title_height display_center" style="width:146px;top: 14.2rem;left: 100.2rem">{{$t('solution_crm.semiconductor.solutions.headline.title08')}}</div>
          <div class="text_title title_height display_center" style="width:160px;top: 46.8rem; left: 116.5rem">{{$t('solution_crm.semiconductor.solutions.headline.title09')}}</div>
          <div class="text_title title_height display_center" style="width:782px;top: 52rem; left: 20rem">{{$t('solution_crm.semiconductor.solutions.headline.title10')}}</div>
          <div class="text_title title_height display_center" style="width:405px;top: 67.2rem; left: 0rem">
            {{$t('solution_crm.semiconductor.solutions.headline.title11')}}
          </div>
          <div class="text_title title_height display_center" style="width:920px;top: 67.2rem; right: 0rem">{{$t('solution_crm.semiconductor.solutions.headline.title12')}}</div>

          <!-- 第一列 代理商门户部分 -->
          <!-- <div class="text_01"> -->

          <div class="text_normal text_normal1" style="top: 7.2rem; left: 6rem;" >
            {{$t('solution_crm.semiconductor.solutions.tab01.title01')}}
          </div>
          <div class="text_normal text_normal1" style="top: 12.8rem; left: 6.7rem">
            {{$t('solution_crm.semiconductor.solutions.tab01.title02')}}
          </div>
          <div class="text_normal text_normal1_1" style="top: 18.4rem; left: 6.7rem">{{$t('solution_crm.semiconductor.solutions.tab01.title03')}}</div>
          <div class="text_normal text_normal1" style="top: 24rem; left: 6.7rem">{{$t('solution_crm.semiconductor.solutions.tab01.title04')}}</div>
          <div class="text_normal text_normal1" style="top: 29.6rem; left: 6.7rem">{{$t('solution_crm.semiconductor.solutions.tab01.title05')}}</div>
          <div class="text_normal text_normal1_2" style="top: 35.4rem; left: 8rem">{{$t('solution_crm.semiconductor.solutions.tab01.title06')}}</div>
          <div class="text_normal text_normal1_3" style="top: 41rem; left: 8rem">{{$t('solution_crm.semiconductor.solutions.tab01.title07')}}</div>
          <div class="text_normal text_normal1" style="top: 46.6rem; left: 6.7rem">{{$t('solution_crm.semiconductor.solutions.tab01.title08')}}</div>
          <div class="text_normal text_normal1 text_normal1_1_ja" style="top: 52.5rem; left: 6.7rem">{{$t('solution_crm.semiconductor.solutions.tab01.title09')}}</div>
          <div class="text_normal text_normal1 text_normal1_2_ja" style="top: 58.3rem; left: 6rem">{{$t('solution_crm.semiconductor.solutions.tab01.title10')}}</div>
          <!-- </div> -->


          <!-- 第二列 第一行 业务分析部分-->
          <div class="text_normal text_normal2_1 text_normal2_1_ja" style="top: 7rem; left: 25.5rem">
            {{$t('solution_crm.semiconductor.solutions.tab02.title01')}}
          </div>
          <div class="text_normal text_normal2 text_normal2_ja" style="top: 7rem; left: 41rem">
            {{$t('solution_crm.semiconductor.solutions.tab02.title02')}}
          </div>
          <div class="text_normal text_normal2_1 text_normal2_1_ja" style="top: 7rem; left: 56rem">
            {{$t('solution_crm.semiconductor.solutions.tab02.title03')}}
          </div>
          <div class="text_normal text_normal2_1 text_normal2_1_ja" style="top: 7rem; left: 71.8rem">
            {{$t('solution_crm.semiconductor.solutions.tab02.title04')}}
          </div>
          <div class="text_normal text_normal2_1 text_normal2_1_ja" style="top: 7rem; left: 87.2rem">
            {{$t('solution_crm.semiconductor.solutions.tab02.title05')}}
          </div>
          <div class="text_normal text_normal2_2 text_normal2_1_ja" style="top: 7rem; left: 101.2rem">
            {{$t('solution_crm.semiconductor.solutions.tab02.title06')}}
          </div>
          
          <!-- 第二列 客户管理部分-->
          <div class="text_normal text_normal3" style="top: 18.65rem; left: 24rem">
            {{$t('solution_crm.semiconductor.solutions.tab03.title01')}}
          </div>
          <div class="text_normal text_normal3" style="top: 24rem; left: 23.2rem">
            {{$t('solution_crm.semiconductor.solutions.tab03.title02')}}
          </div>
          <div class="text_normal text_normal3" style="top: 29.2rem; left: 22.5rem">
            {{$t('solution_crm.semiconductor.solutions.tab03.title03')}}
          </div>
          <div class="text_normal text_normal3_1" style="top: 34.5rem; left: 22.5rem">
            {{$t('solution_crm.semiconductor.solutions.tab03.title04')}}
          </div>
          <div class="text_normal text_normal3_1 text_normal3_1_ja" style="top: 39.7rem; left: 22.5rem">
            {{$t('solution_crm.semiconductor.solutions.tab03.title05')}}
          </div>
          <div class="text_normal text_normal3" style="top: 45rem; left: 23.8rem">
            {{$t('solution_crm.semiconductor.solutions.tab03.title06')}}
          </div>
          <!-- 第三、四列  销售管理部分-->
          <div class="text_normal text_normal4 text_normal4_1_ja" style="top: 18.65rem; left: 40.7rem">
            {{$t('solution_crm.semiconductor.solutions.tab04.title01')}}
          </div>
          <div class="text_normal text_normal4_1 text_normal4_2_ja" style="top: 24rem; left: 39.2rem">
            {{$t('solution_crm.semiconductor.solutions.tab04.title02')}}
          </div>
          <div class="text_normal text_normal4_2" style="top: 29.2rem; left: 39.2rem">
            {{$t('solution_crm.semiconductor.solutions.tab04.title03')}}
          </div>
          <div class="text_normal text_normal4" style="top: 34.5rem; left: 40.7rem">
            {{$t('solution_crm.semiconductor.solutions.tab04.title04')}}
          </div>
          <div class="text_normal text_normal4" style="top: 39.7rem; left: 40.7rem">
            {{$t('solution_crm.semiconductor.solutions.tab04.title05')}}
          </div>
          <div class="text_normal text_normal4" style="top: 45rem; left: 40.7rem">
            {{$t('solution_crm.semiconductor.solutions.tab04.title06')}}
          </div>

          <div class="text_normal text_normal5_1" style="top: 18.65rem; left: 54.58rem">
            {{$t('solution_crm.semiconductor.solutions.tab04.title07')}}
          </div>
          <div class="text_normal text_normal5_2 text_normal5_ja" style="top: 24rem; left: 53.1rem">
            {{$t('solution_crm.semiconductor.solutions.tab04.title08')}}
          </div>
          <div class="text_normal text_normal5_3" style="top: 29.2rem; left: 54.58rem">
            {{$t('solution_crm.semiconductor.solutions.tab04.title09')}}
          </div>
          <div class="text_normal text_normal5_4" style="top: 34.5rem; left: 52.6rem">
            {{$t('solution_crm.semiconductor.solutions.tab04.title10')}}
          </div>
          <div class="text_normal text_normal5_5" style="top: 39.7rem; left: 55.8rem">
            {{$t('solution_crm.semiconductor.solutions.tab04.title11')}}
          </div>

          <!-- 第六列 报价管理部分 -->-
          <div class="text_normal text_normal5_1_ja" style="top: 18.65rem; left: 70.1rem">
            {{$t('solution_crm.semiconductor.solutions.tab05.title01')}}
          </div>
          <div class="text_normal" style="top: 24rem; left: 70.1rem">
            {{$t('solution_crm.semiconductor.solutions.tab05.title02')}}
          </div>
          <div class="text_normal" style="top: 29.2rem; left: 70.1rem">
            {{$t('solution_crm.semiconductor.solutions.tab05.title03')}}
          </div>
          <div class="text_normal" style="top: 34.5rem; left: 70.1rem">
            {{$t('solution_crm.semiconductor.solutions.tab05.title04')}}
          </div>
          <div class="text_normal" style="top: 39.7rem; left: 70.1rem">
            {{$t('solution_crm.semiconductor.solutions.tab05.title05')}}
          </div>

          <!-- 第七列 订单管理部分 -->
          <div class="text_normal text_normal6" style="top: 18.65rem; left: 87.35rem">
            {{$t('solution_crm.semiconductor.solutions.tab06.title01')}}
          </div>
          <div class="text_normal text_normal6 text_normal6_ja" style="top: 24rem; left: 87.35rem">
            {{$t('solution_crm.semiconductor.solutions.tab06.title02')}}
          </div>
          <div class="text_normal text_normal6" style="top: 29.2rem; left: 87.35rem">
            {{$t('solution_crm.semiconductor.solutions.tab06.title03')}}
          </div>
          <div class="text_normal text_normal6" style="top: 34.5rem; left: 87.35rem">
            {{$t('solution_crm.semiconductor.solutions.tab06.title04')}}
          </div>
          <div class="text_normal text_normal6" style="top: 39.7rem; left: 87.35rem">
            {{$t('solution_crm.semiconductor.solutions.tab06.title05')}}
          </div>

          <!-- 第八列 样品管理部分 -->
          <div class="text_normal text_normal7 text_normal7_ja" style="top: 18.65rem; left: 104rem">
            {{$t('solution_crm.semiconductor.solutions.tab07.title01')}}
          </div>
          <div class="text_normal text_normal7 text_normal7_ja" style="top: 24rem; left: 104rem">
            {{$t('solution_crm.semiconductor.solutions.tab07.title02')}}
          </div>
          <div class="text_normal text_normal7 text_normal7_ja" style="top: 29.2rem; left: 104rem">
            {{$t('solution_crm.semiconductor.solutions.tab07.title03')}}
          </div>
          <div class="text_normal text_normal7 text_normal7_1_ja" style="top: 34.5rem; left: 104rem">
            {{$t('solution_crm.semiconductor.solutions.tab07.title04')}}
          </div>
          <div class="text_normal text_normal7 text_normal7_ja" style="top: 39.7rem; left: 104rem">
            {{$t('solution_crm.semiconductor.solutions.tab07.title05')}}
          </div>
          <div class="text_normal text_normal7 text_normal7_ja" style="top: 45rem; left: 104rem">
            {{$t('solution_crm.semiconductor.solutions.tab07.title06')}}
          </div>

          <!-- 第九列 样品管理部分 -->
          <div class="text_normal text_normal8" style="top: 7rem; left: 121.2rem">
            {{$t('solution_crm.semiconductor.solutions.tab08.title01')}}
          </div>
          <div class="text_normal text_normal8_1 text_normal8_1_ja" style="top: 12.18rem; left: 121.2rem">
            {{$t('solution_crm.semiconductor.solutions.tab08.title02')}}
          </div>
          <div class="text_normal text_normal8_2 text_normal8_2_ja" style="top: 17.5rem; left: 121.2rem">
            {{$t('solution_crm.semiconductor.solutions.tab08.title03')}}
          </div>
          <div class="text_normal text_normal8" style="top: 22.65rem; left: 121.2rem">
            {{$t('solution_crm.semiconductor.solutions.tab08.title04')}}
          </div>
          <div class="text_normal text_normal8" style="top: 28rem; left: 119.7rem">
            {{$t('solution_crm.semiconductor.solutions.tab08.title05')}}
          </div>
          <div class="text_normal text_normal8" style="top: 33.3rem; left: 121.2rem">
            {{$t('solution_crm.semiconductor.solutions.tab08.title06')}}
          </div>
          <div class="text_normal text_normal8 text_normal8_3_ja" style="top: 38.5rem; left: 121.2rem">
            {{$t('solution_crm.semiconductor.solutions.tab08.title07')}}
          </div>

          <!-- 倒数第二行 价格管理部分 -->
          <div class="text_normal" style="top: 57.6rem; left: 24.3rem">
            {{$t('solution_crm.semiconductor.solutions.tab09.title01')}}
          </div>
          <div class="text_normal" style="top: 57.6rem; left: 39.6rem">
            {{$t('solution_crm.semiconductor.solutions.tab09.title02')}}
          </div>
          <div class="text_normal" style="top: 57.6rem; left: 55rem">
            {{$t('solution_crm.semiconductor.solutions.tab09.title03')}}
          </div>
          <div class="text_normal" style="top: 57.6rem; left: 70.5rem">
            {{$t('solution_crm.semiconductor.solutions.tab09.title04')}}
          </div>
          <div class="text_normal" style="top: 57.6rem; left: 85.7rem">
            {{$t('solution_crm.semiconductor.solutions.tab09.title05')}}
          </div>

          <!-- 倒数第二行 主数据管理部分 -->
          <div class="text_normal text_normal9 text_normal9_1 text_normal9_1_ja" style="top: 53.4rem; left: 104.45rem">
            {{$t('solution_crm.semiconductor.solutions.tab10.title01')}}
          </div>
          <div class="text_normal text_normal9 text_normal9_2 text_normal9_2_ja" style="top: 53.4rem; left: 114.8rem">
            {{$t('solution_crm.semiconductor.solutions.tab10.title02')}}
          </div>
          <div class="text_normal text_normal9 text_normal9_3" style="top: 53.4rem; left: 123.5rem">
            {{$t('solution_crm.semiconductor.solutions.tab10.title03')}}
          </div>
          <div class="text_normal text_normal9 text_normal9_4" style="top: 58.6rem; left: 103.1rem">
            {{$t('solution_crm.semiconductor.solutions.tab10.title04')}}
          </div>
          <div class="text_normal text_normal9 text_normal9_5" style="top: 58.6rem; left: 110.9rem">
            {{$t('solution_crm.semiconductor.solutions.tab10.title05')}}
          </div>
          <div class="text_normal text_normal9 text_normal9_6" style="top: 58.6rem; left: 118.7rem">
            {{$t('solution_crm.semiconductor.solutions.tab10.title06')}}
          </div>
          <div class="text_normal text_normal9 text_normal9_7 text_normal9_3_ja" style="top: 58.6rem; left: 126.5rem">
            {{$t('solution_crm.semiconductor.solutions.tab10.title07')}}
          </div>
          <!-- 最后一行 -->
          <div class="text_normal text_normal10_1_ja" style="top: 71.9rem; left:7.2rem">
            {{$t('solution_crm.semiconductor.solutions.tab11.title01')}}
          </div>
          <div class="text_normal text_normal10_2_ja" style="top: 71.9rem; left:26.75rem">
            {{$t('solution_crm.semiconductor.solutions.tab11.title02')}}
          </div>
          <div class="text_normal" style="top: 71.9rem; left:51rem">
            {{$t('solution_crm.semiconductor.solutions.tab11.title03')}}
          </div>
          <div class="text_normal" style="top: 71.9rem; left:68.8rem">
            {{$t('solution_crm.semiconductor.solutions.tab11.title04')}}
          </div>
          <div class="text_normal" style="top: 71.9rem; left:86.7rem">
            {{$t('solution_crm.semiconductor.solutions.tab11.title05')}}
          </div>
          <div class="text_normal" style="top: 71.9rem; left:104.8rem">
            {{$t('solution_crm.semiconductor.solutions.tab11.title06')}}
          </div>
          <div class="text_normal text_normal10_3_ja" style="top: 71.9rem; left:122.8rem">
            {{$t('solution_crm.semiconductor.solutions.tab11.title07')}}
          </div>
        </div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'crmSemiconductorSolution',
  data () {
    return {
      bgData: require('../../../../assets/images/IndustrySolution/crm/crmSemiconductor/crm_sem_solution_bg.png'),
    }

  }
}
</script>